import api from '..'
import { DashboardResponse } from './type'

export const getCustomerDashboardStatsFn = async () => {
  const response = await api.get<DashboardResponse>('auth/customer/dashboard')
  return response.data
}
